/**
 * Portal Access Event Service
 * Handles events for portal access changes to notify components to refresh
 */

class PortalAccessEventService {
  constructor() {
    this.listeners = new Set();
  }

  /**
   * Subscribe to portal access change events
   * @param {Function} callback - Function to call when access changes
   * @returns {Function} Unsubscribe function
   */
  subscribe(callback) {
    this.listeners.add(callback);
    
    // Return unsubscribe function
    return () => {
      this.listeners.delete(callback);
    };
  }

  /**
   * Notify all listeners that portal access has changed
   * @param {string} userId - The user ID whose access changed
   */
  notifyAccessChanged(userId) {
    console.log(`Notifying portal access change for user: ${userId}`);
    this.listeners.forEach(callback => {
      try {
        callback(userId);
      } catch (error) {
        console.error('Error in portal access change listener:', error);
      }
    });
  }

  /**
   * Notify that access changed for current user
   * This is a convenience method for when we don't know the specific user ID
   */
  notifyCurrentUserAccessChanged() {
    this.notifyAccessChanged('current');
  }
}

// Create singleton instance
const portalAccessEventService = new PortalAccessEventService();

export default portalAccessEventService;
